import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import cx from "classnames";
import "./style.less";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { PaperComponent } from "../../../utils/helper";
import CheckIcon from "@material-ui/icons/Check";
import CancelIcon from "@material-ui/icons/Cancel";

export default function SuccessDialog({
	isOpen = false,
	infoText = "Congratulations",
	detailInfoText = "",
	OnHandelClick = () => {},
	isError = false,
	AgreeText = "Agree"
}) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<div>
			<Dialog
				fullScreen={fullScreen}
				open={isOpen}
				onClose={() => OnHandelClick(false)}
				className={"success-dialog"}
				PaperComponent={PaperComponent}
			>
				<DialogContent>
					<div className={cx("infoIconCircle", isError && "errorIcon")}>
						{isError ? <CancelIcon /> : <CheckIcon />}
					</div>
					<DialogContentText>
						<h2>{infoText}</h2>
					</DialogContentText>
					<DialogContentText>{detailInfoText}</DialogContentText>
				</DialogContent>
				<DialogActions>
					{AgreeText ? (
						<Button
							onClick={() => {
								OnHandelClick(true);
							}}
							color={"primary"}
							autoFocus
						>
							{AgreeText}
						</Button>
					) : (
						""
					)}
				</DialogActions>
			</Dialog>
		</div>
	);
}
